const OPTIONS = {
    local: 'http://localhost:5000',
    prod: 'https://pet-my-pet-api.vercel.app',
    // prod: 'https://pet-my-pet-server-node.herokuapp.com',
};

const config = {
    SERVER_CONNECTION: OPTIONS.prod,
};

export default config;
